import React, { useCallback, useMemo, useState } from 'react';
import { AdminSaveContext, AdminSaveRegistration, RegisteredSaveHandler } from './AdminSaveContextValue';

export const AdminSaveProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [activeHandler, setActiveHandler] = useState<RegisteredSaveHandler | null>(null);

    const registerSaveHandler = useCallback((routeId: string, registration: AdminSaveRegistration) => {
        setActiveHandler((previous) => {
            if (
                previous &&
                previous.routeId === routeId &&
                previous.hasChanges === registration.hasChanges &&
                previous.isSaving === registration.isSaving &&
                previous.onSave === registration.onSave &&
                previous.onDiscard === registration.onDiscard &&
                previous.saveLabel === registration.saveLabel &&
                previous.discardLabel === registration.discardLabel
            ) {
                return previous;
            }

            return {
                routeId,
                ...registration,
            };
        });
    }, []);

    const unregisterSaveHandler = useCallback((routeId: string) => {
        setActiveHandler((prev) => {
            if (!prev || prev.routeId !== routeId) return prev;
            return null;
        });
    }, []);

    const value = useMemo(
        () => ({
            activeHandler,
            registerSaveHandler,
            unregisterSaveHandler,
        }),
        [activeHandler, registerSaveHandler, unregisterSaveHandler]
    );

    return <AdminSaveContext.Provider value={value}>{children}</AdminSaveContext.Provider>;
};
